import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useCreateInvoiceConfigMutation } from 'queries/invoiceConfig/useCreateInvoiceConfigMutation'

type CreateInvoiceConfigFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useCreateInvoiceConfigMutation>['mutate']
    reset: ReturnType<typeof useCreateInvoiceConfigMutation>['reset']
  }
}

const [Context, useCreateInvoiceConfigFlowContextValue] =
  createContext<CreateInvoiceConfigFlowContextState>({
    name: 'CreateInvoiceConfigFlowContext',
  })

export const CreateInvoiceConfigFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const { mutate, reset, isPending, isError, error } =
    useCreateInvoiceConfigMutation()

  const value: CreateInvoiceConfigFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useCreateInvoiceConfigFlowContextValue }
